import { AxiosRead } from "@/repositories/clients/AxiosReadClient";

const resource = '/main/category_banners';

export default {

  /**
   *  get category_banners
   *  ------------------------
   *  Api address| /api/v1/site/main/category_banners
   *  ------------------------
   *  Method| GET
   *  ------------------------
   *  @Description| get category_banners
   *  ------------------------
   *  @param queryParams {Object} none-required
   *  ------------------------
   *  @return  type {Promise}
   *  ------------------------
   **/
  get(queryParams = null){
    return AxiosRead.get(`${resource}`, {
      params: {
        ...queryParams
      }
    });
  },

}
